import { render, staticRenderFns } from "./scroll-tag.vue?vue&type=template&id=5a64de72&scoped=true"
import script from "./scroll-tag.vue?vue&type=script&lang=js"
export * from "./scroll-tag.vue?vue&type=script&lang=js"
import style0 from "./scroll-tag.vue?vue&type=style&index=0&id=5a64de72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a64de72",
  null
  
)

export default component.exports